export default __webpack_public_path__ + "static/media/WordIcon.ecbac7ec.svg";